import { render, staticRenderFns } from "./MainNavigation.vue?vue&type=template&id=459f0eba"
import script from "./MainNavigation.vue?vue&type=script&lang=ts"
export * from "./MainNavigation.vue?vue&type=script&lang=ts"
import style0 from "./MainNavigation.vue?vue&type=style&index=0&id=459f0eba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports